





































































































































































import Vue from 'vue';
import { namespace } from "vuex-class";
import { Component, Prop } from 'vue-property-decorator';
import { httpClient } from '../../core';
import { env } from '@/env';

const TranslateStore = namespace("translate");

@Component({
  name: 'FeedbackComponent'
})
export default class FeedbackComponent extends Vue {
  @Prop({ default: '' }) readonly documentId!: string;

  @TranslateStore.Action
  public addFeedback!: (payload: any) => Promise<void>;

  private feedbackFormValid: boolean;
  private originalFile: any;
  private originalFileName: string;
  private translatedFile: any;
  private translatedFileName: string;
  private comments: string;
  private recipient: string;
  private sendingFeedback: boolean;
  private dialogMessage: string;
  private messageColor: string;
  private messageText: string;
  private showMessage: boolean;
  private isError: boolean;
  private isLocal: boolean = env.environment === 'local';

  constructor() {
    super();
    this.feedbackFormValid = false;
    this.comments = '';
    this.recipient = '';
    this.originalFileName = '';
    this.translatedFileName = '';
    this.sendingFeedback = false;
    this.dialogMessage = '';
    this.messageColor = 'white';
    this.showMessage = false;
    this.messageText = '';
    this.isError = false;
  }

  public handleOriginalFile(): void {
    this.originalFile = (this.$refs.originalFile as Vue & { files: any }).files[0];
    if(this.originalFile)
      this.originalFileName = this.originalFile.name;
    else
      this.originalFileName = '';
  }
  private clearOriginal() {
    this.originalFile = undefined;
    this.originalFileName = '';
    (this.$refs.originalFile as any).value = '';
  }

  public handleTranslatedFile(): void {
    this.translatedFile = (this.$refs.translatedFile as Vue & { files: any }).files[0];
    if(this.translatedFile)
      this.translatedFileName = this.translatedFile.name;
    else
      this.translatedFileName = '';
  }
  private clearTranslated() {
    this.translatedFile = undefined;
    this.translatedFileName = '';
    (this.$refs.translatedFile as any).value = '';
  }

  public submitFeedback(): void {
    if ((this.$refs.feedbackForm as Vue & { validate: () => boolean }).validate()) {
      this.sendingFeedback = true;
      this.dialogMessage = 'Sending feedback, please wait ...';

      this.originalFile = null;
      const originalReference = (this.$refs.originalFile as Vue & { files: any });
      if(originalReference && originalReference.files.length > 0)
        this.originalFile = originalReference.files[0];

      this.translatedFile = null;
      const translatedReference = (this.$refs.translatedFile as Vue & { files: any });
      if(translatedReference && translatedReference.files.length > 0)
        this.translatedFile = translatedReference.files[0];

      const formData = new FormData();
      const options = {
        Comments: this.comments,
        Recipient: this.recipient
      };
      formData.append('OriginalFile', this.originalFile);
      formData.append('TranslatedFile', this.translatedFile);
      formData.append('Options', JSON.stringify(options));

      const docIdPart = this.documentId ? `/${this.documentId}` : '';
      httpClient.instance
        .post(`${env.apiUrl}/feedback/${env.applicationId}${docIdPart}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then( () => {
          this.comments = ""; // empty field will cause invalidform to av
          this.displayInfo("Feedback sent successfully");
        })
        .catch((error) => {
          this.displayInfo('Error sending Feedback, please check your network connection', error);
        })
        .finally(() => {
          this.sendingFeedback = false;
        });

      //Feedback Service
      this.addFeedback({
        applicationId: env.environment, //NOTE: optional, can be used as subapp (upload/list/stats) or env (local, dev, uat, prod)
        firstFile: this.originalFile,
        secondFile: this.translatedFile,
        url: window.location.href,
        text: options.Comments,
        //isAnonymous: this.isAnonymous
      })
      .then(async () => {
        //this.displayInfo("Feedback added successfully");
      })
      .catch(error =>{
        this.displayInfo('Error adding feedback, please contact us if this problem persists. Thanks', error);
        console.error(error);
      })
      .finally(() => {
        this.sendingFeedback = false;
      })
      ;
    }
  }

  private displayInfo(text: string, error = '') {
    this.messageText = text;
    this.messageColor = error ? 'error' : 'sgsOrange';
    this.showMessage = true;
    this.isError = error.length > 0 ? true : false;
    if (error) console.error(text, error);
  }
}
